import { fetchQuery, graphql } from "relay-runtime"
import {
  betterDocRemoteRecommendationsQuery,
  betterDocRemoteRecommendationsQuery$data,
} from "@/modules/admin/better-doc/services/__generated__/betterDocRemoteRecommendationsQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"
import { Country, de_BetterDocRecommendationStateGroup } from "@/types/__generated__/union-types"

const query = graphql`
  query betterDocRemoteRecommendationsQuery(
    $insuranceCountry: Country!
    $stateGroup: de_BetterDocRecommendationStateGroup!
    $updatedAfter: Date!
  ) {
    de_betterDocRemoteRecommendations(
      insuranceCountry: $insuranceCountry
      stateGroup: $stateGroup
      updatedAfter: $updatedAfter
    ) {
      status
      httpStatusCode
      errorReason
      exchangeId
      hasMoreRecommendations
      recommendations {
        recommendationId
        state
        recommendationDelivery
        secondOpinion
        updatedAt
        partnerPatientId
        partnerSessionId
        localSessionId
        medics {
          selectionId
        }
      }
    }
  }
`

export type BetterDocRecommendationsResult =
  betterDocRemoteRecommendationsQuery$data["de_betterDocRemoteRecommendations"]

export type BetterDocRecommendationSummary = BetterDocRecommendationsResult["recommendations"][number]

export const fetchBetterDocRecommendations = (
  insuranceCountry: Country,
  stateGroup: de_BetterDocRecommendationStateGroup,
  updatedAfter: string,
): Promise<BetterDocRecommendationsResult> =>
  fetchQuery<betterDocRemoteRecommendationsQuery>(
    RelayEnvironment,
    query,
    { insuranceCountry, stateGroup, updatedAfter },
    { fetchPolicy: "network-only" },
  )
    .toPromise()
    .then((response) => {
      if (!response) {
        throw new Error("BetterDoc returned no response")
      }

      return response.de_betterDocRemoteRecommendations
    })
